// OVERWRITE SIDEBASE REFRESH HANDLER IN ORDER TO DISABLE IT (we handle refresh in useFetchAPi composable)

class CustomRefreshHandler {
  init(): void {}
  destroy(): void {}
}

export default new CustomRefreshHandler()
